import React from "react";

import { LinkHandler } from "@/components/common/LinkHandler";
import { ArrowRightNav } from "@/components/icons/ArrowRightNav";
import { TextElementMen } from "@/components/ui-kit/TextElementMen/TextElementMen";
import { HeaderDataItem } from "@/data/navigation/header.data";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";

interface MenNavigationShopContentProps {
  item: HeaderDataItem;
}

const trackClicked = (text: string, destination: string) => {
  GA4.onNavigationClicked({
    type: "button",
    text,
    destination,
  });
};

const MenNavigationShopSubCategory: React.FC<MenNavigationShopContentProps> = ({ item }) => {
  const title = item.rootCauseCategoriesTitle;
  const items = item.children?.filter((el) => el.mode === "root-cause") ?? [];

  return (
    <div className="pt-8 pb-4">
      <div className="px-4 pb-4">
        <TextElementMen
          text={title}
          className={`text-nova-base-black Title-10-Super-Normal uppercase`}
        />
      </div>
      <ul className={cn("flex flex-col")}>
        {items?.map((child, index) => (
          <li key={index} className={"group hover:bg-nova-base-solid-20 transition-colors"}>
            <LinkHandler
              path={child.url}
              className="block p-4"
              onClick={() => trackClicked(child.title, child.url)}
            >
              <div className="flex items-center gap-1">
                <div>
                  <TextElementMen
                    text={child.longName || child.title}
                    className="text-nova-base-black Body-20-Dia-Normal"
                  />
                </div>
                <div className={`ml-auto invisible group-hover:visible`}>
                  <ArrowRightNav className={` text-nova-base-white rounded w-6 h-6`} />
                </div>
              </div>
            </LinkHandler>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MenNavigationShopSubCategory;
